import { arrayOf, element, func, string } from "prop-types";

import { FormsPageHeader } from "./styled";

export const FormsHeader = ({ onBack, subTitle, extra }) => (
  <FormsPageHeader onBack={onBack} subTitle={subTitle} extra={extra} />
);

FormsHeader.propTypes = {
  onBack: func,
  subTitle: string,
  extra: arrayOf(element),
};
